import { createFileRoute } from "@tanstack/react-router";
import { SpokePage, buildSpokeHead, type SpokePageConfig } from "@/components/SpokePage";
import heroImg from "@/assets/towns/ellicott.jpg";

const CONFIG: SpokePageConfig = {
  slug: "web-design-seo-ellicott",
  metaTitle: "Ellicott Web Design & SEO | Local Google Maps Help",
  metaDescription: "Web design and SEO for Ellicott, CO businesses. Websites from $1,850, local SEO and Google Maps from $950/month. Based in Colorado Springs, month-to-month.",
  breadcrumbs: [{ label: "Home", to: "/" }, { label: "Colorado Springs Headquarters", to: "/colorado-springs-headquarters" }],
  currentLabel: "Ellicott",
  eyebrow: "Ellicott, CO · El Paso County",
  h1: (
    <>
      Web Design &amp; SEO in <span className="text-brand-gold">Ellicott, Colorado</span>
    </>
  ),
  heroDescription: "Help Ellicott customers find you first on Google, Google Maps and AI search.",
  intro: "We build websites and local SEO for businesses in Ellicott and eastern El Paso County. Chris Heidlebaugh works from our Woodmen Rd office in Colorado Springs, within our 60-mile service area, with 27 years of experience helping local companies get found.",
  definition: { term: "Ellicott local SEO", body: "Making your business show up when people in and around Ellicott search Google, Google Maps and AI tools for what you offer." },
  whatWeDo: [
    { title: "Ellicott website", body: "A fast site with pages for your services and the Ellicott area." },
    { title: "Google Maps", body: "A complete profile with photos, services and steady reviews." },
    { title: "Nearby towns", body: "Pages for Calhan, Peyton and Fountain too." },
    { title: "AI search", body: "Plain answers ChatGPT and Google can repeat." },
    { title: "Clear pricing", body: "Websites from $1,850. Marketing from $950/mo." },
    { title: "Free audit", body: "See what is holding your Ellicott rankings back." },
  ],
  whyThisMarket: [
    { heading: "Local searches", body: "Customers here often search for businesses that serve rural properties and long drives." },
    { heading: "El Paso County", body: "We know El Paso County and serve it from Colorado Springs." },
    { heading: "No long contracts", body: "Monthly marketing is month-to-month." },
  ],
  relatedLinks: [
    { to: "/marketing-ellicott", label: "Marketing in Ellicott: social, ads, reviews & Maps" },
    { to: "/colorado-springs-headquarters", label: "Our 60-mile service area" },
    { to: "/colorado-springs-office-woodmen-rd", label: "Our Woodmen Rd office" },
    { to: "/pricing", label: "Pricing" },
    { to: "/free-mockup", label: "Get a free website mockup" },
    { to: "/free-audit", label: "Get a free marketing audit" },
    { to: "/web-design-castle-rock-colorado", label: "Castle Rock web design company" },
  ],
  faqs: [
    { q: "Do you work with businesses in Ellicott?", a: "Yes. Ellicott is in our 60-mile service area around Colorado Springs. We can meet in person or by video." },
    { q: "How much does a website cost?", a: "Websites are $1,850, $2,750 or $5,950 one-time with one year of hosting and SSL. Monthly marketing is $950, $1,650 or $2,750 per month." },
    { q: "How fast can my website be ready?", a: "Most websites are ready in under 7 business days." },
  ],
  serviceName: "Web Design and SEO in Ellicott, CO",
  serviceDescription: "Web design, local SEO and Google Maps help for Ellicott, Colorado businesses.",
  heroImage: { src: heroImg, alt: "Ranch land in Ellicott, Colorado on the high plains", geo: { lat: 38.8383, lng: -104.3869, city: "Ellicott, CO" } },
  areaServed: "Ellicott, CO",
};

export const Route = createFileRoute("/web-design-seo-ellicott")({
  head: () => buildSpokeHead(CONFIG),
  component: () => <SpokePage config={CONFIG} />,
});
